export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7221.81ab68bb.jpg";